import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {RestService} from "../../services/rest.services.service";
import {
  capturarFile,
  validateSizeFile,
  decodeBase64,
  mostrarToast,
  closeModal,
  openModal,
  convertirPrimeraLetraMayuscula
} from "../../utils/utilities";
import {ServiceNotificationService} from "../../services/service-notification.service";
import {DomSanitizer} from "@angular/platform-browser";
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import { environment } from "../../../environments/environment";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {NotificationsComponent} from "../../notifications/notifications.component";
import {toASCII} from "node:punycode";
import {NgIf} from "@angular/common";
import {HttpHeaders} from "@angular/common/http";



@Component({
  selector: 'app-main-screen',
  standalone: true,
  imports: [
    NotificationsComponent,
    RouterLink,
    NgIf
  ],
  templateUrl: './main-screen.component.html',
  styleUrl: './main-screen.component.css'
})
export class MainScreenComponent implements OnInit {

  public archivos: any = [];
  @ViewChild('inputXML') inputXML!: ElementRef;
  @ViewChild('inputPDF') inputPDF!: ElementRef;
  @ViewChild('botonEnviar') botonEnviar!: ElementRef;
  @ViewChild('modalNothing') modalNothing!: ElementRef;
  previewImage: any;
  formDataOfDocument: FormGroup = new FormGroup({});
  codigoOrden: any = null;
  isDisabled: boolean = false;
  nombreProveedor: string = '';
  totalPagarFactura: number = 0;
  codOrden : number = 0;
  hashedPassword  : string | null='';
  validateOrden: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private restService: RestService,
    private serviceNotifications: ServiceNotificationService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private rendered: Renderer2
  ) {
  }

  async ngOnInit() {

    this.route.paramMap.subscribe(async params => {
      try {
        const result = this.extracDataOfUrl(
          window.location.href
        );
        this.codigoOrden = result.codigoOrden;
        this.hashedPassword = result.hashedPassword;
      } catch (error) {
        console.error("Error:" + error);
      }

      if (this.hashedPassword != null) {
        this.hashedPassword = decodeURIComponent(this.hashedPassword);
      }

      const isOrdenValid = await this.validateDataOfOrden(this.hashedPassword, this.codigoOrden);
      if (this.codigoOrden !== null && isOrdenValid) {
        if (!this.codigoOrden) {
          this.disableButton();
          return;
        } else {
          this.obtenerDataOfOrden(this.codigoOrden);
        }
      } else {
        this.mostrarToast('El código de la orden no es válido', false);
      }
    });


    this.formDataOfDocument = this.fb.group({
      codigoOrden: ['', [Validators.required]],
      documentXml: ['', [Validators.required]],
      routePdf: ['', [Validators.required]],
    });


  }



  capturarArchivo(event: Event, element: string, codigoOrden: number): void {
    const input = event.target as HTMLInputElement;
    let validate;
    if (input && input.files) {
      for (let i = 0; i < input.files.length; i++) {
        validate= validateSizeFile(input.files[i].size);
        if (!validate) {
          this.mostrarToast('El tamaño de los documentos no puede ser mayor a 5MB', false);
          if (element === 'xml') {
            this.inputXML.nativeElement.value = '';
          }else {
            this.inputPDF.nativeElement.value = '';
          }
          return;
        }
      }
    }

    capturarFile(event, this.sanitizer, this.archivos,(preview) => this.previewImage = preview);
  }

  enableButton(): void {
    this.isDisabled = false;
  }
  disableButton(): void {
    this.isDisabled = true;
  }


  async validateDataOfOrden(hashedPassword: string | null, codOrden: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.restService.post({
        body: {
          hashedPassword: hashedPassword,
          codigoOrden: codOrden,
        },
        url: environment.apiCheckUrl,
      }).subscribe((res: any) => {
        resolve(res.valid); // Resolvemos la Promise con el valor de `res.valid`
      }, (error) => {
        console.error('Error en la validación de la orden:', error);
        resolve(false); // En caso de error, asumimos que no es válida
      });
    });
  }


  obtenerDataProveedor(cod_proveedor: number){
    this.restService.post(
      {
      body: {
        id: cod_proveedor
      },
      url: environment.apiGetDataOfProveedor
    }) .subscribe((res: any)=>{
      const  {nombreComercial } = res;
      this.nombreProveedor = convertirPrimeraLetraMayuscula(nombreComercial);
    })

  }



  obtenerDataOfOrden(codOrden: number){
    this.codOrden= codOrden;
    this.restService.post(
      {
        body: {
          id: codOrden
        },
        url: environment.apiGetDataOfOrden
      })
      .subscribe((res: any) => {
        if (res.cod != 200){
          this.mostrarToast('Error al obtener la información de la orden', false);
          this.disableButton();
          return;
        }

        const {cod_proveedor, total } = res;
        let codProveedor;
        codProveedor = cod_proveedor;
        this.totalPagarFactura = total;
        if (codProveedor){
          this.obtenerDataProveedor(codProveedor)
        }

        this.enableButton();
        this.formDataOfDocument.patchValue({
          codigoOrden: this.codOrden
        });
      });
  }






  mostrarToast(message: string, type: boolean) {
    this.serviceNotifications.recibeNotificacion.emit({
      mensaje: message,
      tipo: type
    })
  }






  sendFiles(): void {

    const headers = new HttpHeaders({
      'codOrden': this.codOrden
    })


    const files = new FormData();
    this.archivos.forEach((archivo: any) => {
      files.append('files', archivo);
    });
    files.append('codigoOrden', this.codigoOrden);
    this.restService.postJava({
      url: environment.apiUploadDocuments,
      body: files,
      options: {
        headers
      }
    })
      .subscribe((res: any) => {
        if (res.cod !== 200) {
          this.mostrarToast('Error al subir los documentos', false);
          return;
        }
        this.mostrarToast('Documentos subidos correctamente', true);
        this.inputXML.nativeElement.value = '';
        this.inputPDF.nativeElement.value = '';

      })
  }


  extracDataOfUrl(url: string) {
    const processUrl = () => {
      const currentUrl = url;

      const start = currentUrl.indexOf("uploadDocuments/") + "uploadDocuments/".length;

      const remainingPath = currentUrl.substring(start);

      const segments = remainingPath.split("/");

      const codigoOrden = segments.pop() || ""; // Si no existe, devolverá un string vacío

      const hashedPassword = segments.join("/");

      if (!hashedPassword || !codigoOrden) {
        throw new Error("No se pudo procesar la URL correctamente. Datos faltantes.");
      }

      return { hashedPassword, codigoOrden };
    };

    return processUrl();
  }

}
